import React from 'react'
import Arrow from '../../../assets/images/arrow.svg'
import styles from './NavigationCard.module.scss'
import { useNavigate } from 'react-router-dom'
import classNames from 'classnames'
import { isArabic } from '../../../utils'
import { useLanguage } from '../../../context/LangaugeContextProvider/LangaugeContextProvider'

const NavigationCard = ({ navigation }) => {
  const navigate = useNavigate()
  const { language } = useLanguage()
  const handleNavigate = (path) => {
    navigate(path)
  }
  return (
    <div
      className={classNames(
        styles['card-container'],
        'flex flex-column justify-between cursor-pointer'
      )}
      onClick={() => handleNavigate(navigation?.link?.path)}
    >
      <div className={classNames(styles.content)}>
        <div className={classNames(styles['module-name'])}>
          {navigation?.cardfirstcontent}
        </div>
        <div className={classNames(styles['submodule-name'])}>
          {navigation?.cardmaincontent}
        </div>
      </div>
      <div className="absolute bottom-0 w-full flex items-center justify-end">
        {/* <div className={classNames(styles['action-text'])}>
          {/* {navigation.cardlastcontent} /}
        </div> */}
        <div
          className={classNames(
            styles['animated-action-wrapper'],
            'bg-white relative',
            {
              [styles['arabic-animated-action-wrapper']]: isArabic(
                language.code
              ),
            }
          )}
        >
          <img
            src={Arrow}
            alt="Arrow"
            className={classNames(
              styles['action-image'],
              'block cursor-pointer'
            )}
          />
        </div>
      </div>
    </div>
  )
}
export default NavigationCard
